// extracted by mini-css-extract-plugin
export default {"container":"Logout_container__7KeSI","img":"Logout_img__FE5P4","btn":"Logout_btn__L7cAi"};